import moment from 'moment';

export const toTrendKey = (date: Date) => moment(new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000))
    .format('DD-MM-YYYY');
